import { useEffect, useState, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { Dropdown } from 'antd';
import { isStringEmpty } from '@shared/utils';
import { getSuggestMessages } from '@/services/chat';
import chatStoreManager from '@/store/chat/manager';
import modelChoiceStore from '@/components/model-choice/store';
import navbarStore from '@/store/navbar';
import appLogger from '@public/log/monitor';
import { shuffle } from 'lodash-es';
import { HelperCore } from '@/common/helper';
import { getFixedRenewData } from '@shared/store/chat';
import EE from '@/common/event';
import globalStore from '@/store/global';
import inputTypeStore from '../input-file/input-type';

const DropdownList = ({ allList = [], chatId }) => {
  return (
    <div
      style={{
        boxShadow: '0px 0px 16px 0px rgba(0,0,0,0.1)',
      }}
      className="w-full bg-[var(--bg-dropdown)] pt-20px pl-8px pr-4px rounded-8px mb-4px border-1px border-solid border-black border-opacity-10"
    >
      <div className="text-14px text-primary font-bold leading-20px ml-8px mb-8px">
        选择模型
      </div>
      <div className="h-316px overflow-y-auto nw-scrollbar">
        {allList.map(item => {
          if(item.conversation_type == 1) return // 文生图模型需要排除
          return (
            <div
              key={item.id}
              onClick={evt => {
                const chatStore = chatStoreManager.current;
                const { lastMessage } = chatStore;
                chatStore.sendMessage({
                  asstId: item.id,
                  input: lastMessage.prompt,
                  compare_parent_id:
                    lastMessage.compare_parent_id || lastMessage.msg_id,
                  ...getFixedRenewData(lastMessage),
                });
                appLogger.log({
                  key: 'aibot_chat',
                  action: 'click',
                  arrt: 'comparison_bot',
                  ext: item.title,
                  role_id: item.id,
                  conversation_id: chatId,
                  message_id: lastMessage.msg_id,
                });
              }}
              className="flex items-center justify-between h-40px pl-8px pr-12px mb-6px rounded-8px cursor-pointer hover:bg-[var(--bg-dropdown-hover)]"
            >
              <div className="flex items-center">
                <img
                  className="size-24px rounded-8px mr-8px"
                  src={item.icon}
                  alt=""
                />
                <span className="text-14px font-bold text-primary">
                  @{item.title}
                </span>
              </div>
              <SVGPureIcon name="arrow_right" className="size-16px !text-primary" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const CompareItem = observer(({
  content,
  list = [],
  isMore,
  chatId,
  messageId,
  open,
  knowledgeId,
  kn_continue_chat,
  entrance,
}) => {
  return (
  <div>
    <div
      className={[
        'group inline-flex items-center',
        'h-40px mb-8px pr-18px rounded-12px overflow-hidden cursor-pointer',
        globalStore.isDark ? 'bg-secondary hover:bg-[#282832] border-[rgba(255,255,255,.1)]' : 'hover:bg-gray-nav-hover',
        'bg-gray-nav',
      ]}
      onClick={() => {
        const chatStore = chatStoreManager.current;
        const { lastMessage } = chatStore;
        if (isMore) {
          appLogger.log({
            key: 'aibot_chat',
            action: 'click',
            arrt: 'comparison_bot_more',
            conversation_id: chatId,
            message_id: lastMessage.msg_id,
          });
        } else {
          // 防止出现多个流同时回答
          if(lastMessage.is_doing) return

          chatStoreManager.setNewChatLogData({
            key: appLogger.getRouterName(),
            input_type: "more_question",
          });
          
          const { role_id, agentId } = chatStore.messageMap.get(messageId);
          if(globalStore.isKownledgeChat()){
            chatStore.sendMessage({
              asstId: role_id,
              agentId,
              input: content,
              ...(
                knowledgeId
                  ? {
                    dataset: {
                      [knowledgeId]: [],
                    },
                  }
                  : {}
              ),
              ...{ dataset_src: 1 },
            });
          }
          else {
            chatStore.sendMessage({
              input: content,
              ...inputTypeStore.getSendParams(),
              ...Object.keys(kn_continue_chat || {}).length > 0 ? {kn_continue_chat} : {},
              entrance,
            });
          }

          chatStore.log({
            action: "click",
            set: "more_question",
            message_id: messageId,
          });
        }
      }}
    >
      <div className="h-full flex items-center pr-18px flex-1">
        <div className="h-full leading-38px pl-16px text-14px text-primary line-clamp-1 break-all">
          {isMore ? '选择其他模型回答' : content}
        </div>
        {isMore ? (
          <div className="flex item-center ml-auto">
            {list.map(item => {
              return (
                <div
                  key={item.id}
                  className={["size-24px p-2px -ml-6px rounded-6px overflow-hidden", globalStore.isDark? "bg-[#31313A] group-hover:bg-[#31313A]": "bg-white group-hover:bg-[#F0F2F5]"]}
                >
                  <img
                    src={item.dl_icon || item.icon}
                    className="size-20px rounded-6px"
                    alt=""
                  />
                </div>
              );
            })}
            <div
              key={'more'}
              className={["size-24px p-2px -ml-6px rounded-6px overflow-hidden", globalStore.isDark? "bg-[#31313A] group-hover:bg-[#31313A]": "bg-white group-hover:bg-[#F0F2F5]"]}
            >
              <div className={["size-20px vh-center rounded-6px",globalStore.isDark?"bg-[#2A2A34]":"bg-[#F6F7F9]"]}>
                <SVGPureIcon name="icon_more" className={["w-14px h-4px", globalStore.isDark ? "text-white" : ""]} />
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {isMore ? (
        <SVGPureIcon
          name="arrow_top"
          className={[
            'w-12px h-7px transform transition-all',
            open ? 'rotate-0' : 'rotate-180',
          ]}
        />
      ) : (
        <SVGPureIcon name="arrow_right" className="size-16px flex-shrink-0" />
      )}
    </div>
  </div>
  );
});

const GuessAndCompare = observer(props => {
  const [popupVisible, setPopupVisible] = useState(false);
  const { chatId, messageId, asstInfo, excludeModelId, supportCompare = true, isAgentWelcome, knowledgeId, kn_continue_chat, entrance } = props;
  const [ask_further, setAskFurther] = useState(props.ask_further || []);
  const chatStore = chatStoreManager.current;

  const list = useMemo(() => {
    const _list = HelperCore.uniqueArray(
      modelChoiceStore.list.filter(item => item.id != excludeModelId),
      'icon'
    );
    return shuffle(_list).slice(0, 3);
  }, [excludeModelId]);

  const allList = (modelChoiceStore?.list || []).filter(item => item.id != excludeModelId);

  //页面滚动时隐藏dropdown
  useEffect(() => {
    const hideDropdown = () => {
      setPopupVisible(false);
    };
    EE.on('scroll_hide_dropdown', hideDropdown);

    return () => {
      EE.off('scroll_hide_dropdown', hideDropdown);
    };
  }, []);

  useEffect(() => {
    const asyncGetMessages = async () => {
      if (isStringEmpty(chatId)) {
        return;
      }
      // 部分智能体，不加载追问
      try{
        if(chatStore.mcpStore.agentInfo.ask_further_enable === false){
          return;
        }
      } catch(e){}
      const { code, data } = await getSuggestMessages(chatId, messageId);
      const { lastMessage } = chatStore;

      if (
        code == 0 &&
        Array.isArray(data) &&
        lastMessage?.msg_id === messageId
      ) {
        setAskFurther(data.slice(0, 3));

        try {
          chatStoreManager.current.stepsLogger.record('ask_further');
          const logData = chatStoreManager.current.log({}, true);
          const ext2 = logData.ext2;
          delete(logData.ext2);
          chatStoreManager.current.stepsLogger.done(messageId, true, {
            arrt: chatStoreManager.current.lastChatType,
            ext4: lastMessage.result?.length || "",
            ext6: ext2,
            message_id: lastMessage.msg_id,
            ...logData,
          });
        } catch (e) {}
      }
    };
    if (ask_further.length > 3) {
      setAskFurther(ask_further.slice(0, 3));
    } else {
      asyncGetMessages();
    }
  }, []);

  return (
    <div className="">
      <div className="table w-full">
        {ask_further.map((item, index) => {
          return (
            <CompareItem
              key={index}
              content={item.content}
              chatId={chatId}
              messageId={messageId}
              open={popupVisible}
              knowledgeId={knowledgeId}
              kn_continue_chat={kn_continue_chat}
              entrance={entrance}
            />
          );
        })}
        {false && chatStore.isChatModelChat && list.length && supportCompare ? (
          <Dropdown
            key="compare_more"
            trigger="click"
            placement="bottomLeft"
            open={popupVisible}
            onOpenChange={open => setPopupVisible(open)}
            dropdownRender={() => (
              <DropdownList allList={allList} chatId={chatId} />
            )}
          >
            <div>
              <CompareItem
                list={list}
                isMore={true}
                chatId={chatId}
                messageId={messageId}
                open={popupVisible}
              />
            </div>
          </Dropdown>
        ) : null}
      </div>
    </div>
  );
});

export default GuessAndCompare;
